import type { DynamicYieldPageView } from './types/dynamicYieldTypes'

export async function dynamicYieldContextPage({
  page: pageType,
  data = [],
}: DynamicYieldPageView) {
  try {
    window.DY = window.DY || {}

    window.DY.recommendationContext = {
      type: pageType,
      data,
    }
  } catch (error) {
    console.error('Falha ao aplicar DY context:', error.message)
  }
}
